interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPageList(page: number, totalPages: number): (number | "dots")[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const pages: (number | "dots")[] = [1];
  if (page > 3) pages.push("dots");
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  for (let current = start; current <= end; current += 1) pages.push(current);
  if (page < totalPages - 2) pages.push("dots");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = getPageList(page, totalPages);

  return (
    <nav className="mt-10 flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="w-9 h-9 rounded-md border border-background-200/80 text-foreground-700 flex items-center justify-center transition-colors cursor-pointer hover:border-primary-500 hover:text-foreground-950 disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:border-background-200/80"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((item, index) =>
        item === "dots" ? (
          <span key={`dots-${index}`} className="w-9 h-9 flex items-center justify-center text-foreground-500 text-sm">
            ···
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
              item === page
                ? "bg-primary-500 text-foreground-950"
                : "border border-background-200/80 text-foreground-700 hover:border-primary-500 hover:text-foreground-950"
            }`}
            aria-current={item === page ? "page" : undefined}
          >
            {item}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="w-9 h-9 rounded-md border border-background-200/80 text-foreground-700 flex items-center justify-center transition-colors cursor-pointer hover:border-primary-500 hover:text-foreground-950 disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:border-background-200/80"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}